import {
  QA_MENU,
  QA_CONTENT,
  LEGISLATION,
  LEGISLATION_FOLDERS,
  CURRENT_AWARENESS,
  DASHBOARD,
  MW_OVERVIEW,
  DOCUMENTS_MENU
} from 'constants/controllers'
import { DEFAULT_FLAVOUR } from 'constants/flavours'
import { URL_FC_TRAINING_SIGN_IN, URL_TRAINING } from 'constants/links'
import {
  CORPORATE_MARKETS_PREMIUM,
  EMPLOYMENT_MARKETS_PREMIUM,
  NEWS_ACCESS_CONTENT,
  QA_ACCESS_CONTENT,
  LEGISLATION_ACCESS_CONTENT,
  DOCUMENTS_ACCESS_CONTENT,
  MARKETS_ACCESS_CONTENT
} from 'constants/access-roles'
import {
  SECTION_MAPPINGS,
  SECTION_NEWS,
  SECTION_QA,
  SECTION_LEGISLATION,
  SECTION_DOCUMENTS,
  SECTION_MARKETS
} from './aol/sections'

export const headerNav = [
  {
    title: 'News',
    target: DASHBOARD,
    params: {},
    activeClass: 'light-sea-green-2',
    highlightPages: SECTION_MAPPINGS[SECTION_NEWS],
    searchType: 'ca'
  },
  {
    title: 'Q&A',
    target: QA_MENU,
    params: {},
    activeClass: 'medium-turquoise',
    highlightPages: SECTION_MAPPINGS[SECTION_QA],
    searchType: 'qa'
  },
  {
    title: 'Legislation',
    target: LEGISLATION_FOLDERS,
    params: {},
    activeClass: 'dark-orchid',
    highlightPages: SECTION_MAPPINGS[SECTION_LEGISLATION],
    searchType: 'legislation'
  },
  {
    title: 'Documents',
    target: DOCUMENTS_MENU,
    params: {},
    activeClass: 'teal',
    highlightPages: SECTION_MAPPINGS[SECTION_DOCUMENTS],
    searchType: 'precedents'
  },
  {
    title: 'Markets',
    target: MW_OVERVIEW,
    params: {},
    activeClass: 'dark-sea-green-3',
    highlightPages: SECTION_MAPPINGS[SECTION_MARKETS]
  },
  {
    title: 'Learning',
    url: URL_FC_TRAINING_SIGN_IN,
    alternativeUrl: URL_TRAINING,
    params: {},
    activeClass: 'chocolate',
    roles: [],
    externalLink: true
  }
]

export const searchMenu = [
  {
    title: 'Q&A',
    target: QA_CONTENT,
    params: {},
    typeName: 'qa',
    activeClass: 'qa-search-button',
    icon: 'icon-qa-search-variant',
    roles: [QA_ACCESS_CONTENT]
  },
  {
    title: 'Legislation',
    target: LEGISLATION,
    position: 'search',
    params: { flavour: DEFAULT_FLAVOUR },
    typeName: 'legislation',
    activeClass: 'legislation-search-button',
    icon: 'icon-legislation-search-variant',
    roles: [LEGISLATION_ACCESS_CONTENT]
  },
  {
    title: 'News',
    target: CURRENT_AWARENESS,
    params: {},
    typeName: 'ca',
    activeClass: 'news-search-button',
    icon: 'icon-news-archive-search-variant',
    roles: [NEWS_ACCESS_CONTENT]
  },
  {
    title: 'Documents',
    target: DOCUMENTS_MENU,
    params: {},
    typeName: 'documents',
    activeClass: 'precedents-search-button',
    icon: 'icon-documents-search-variant',
    roles: [DOCUMENTS_ACCESS_CONTENT]
  },
  {
    title: 'Markets',
    target: 'dealwatch',
    position: 'search',
    params: {},
    typeName: 'dealwatch',
    activeClass: 'markets-search-button',
    icon: 'icon-markets-search-variant',
    roles: [MARKETS_ACCESS_CONTENT]
  }
]

export const footerMenu = [
  {
    title: 'Q&A',
    target: QA_MENU,
    params: {},
    roles: []
  },
  {
    title: 'Legislation',
    target: LEGISLATION_FOLDERS,
    params: {},
    roles: []
  },
  {
    title: 'News',
    target: CURRENT_AWARENESS,
    params: {},
    roles: []
  },
  {
    title: 'Documents',
    target: DOCUMENTS_MENU,
    params: {},
    roles: []
  },
  {
    title: 'Markets',
    target: MW_OVERVIEW,
    params: {},
    roles: [CORPORATE_MARKETS_PREMIUM, EMPLOYMENT_MARKETS_PREMIUM]
  },
  {
    title: 'Learning',
    target: URL_FC_TRAINING_SIGN_IN,
    alternativeUrl: URL_TRAINING,
    roles: []
  }
]

export default {
  headerNav,
  search: searchMenu,
  footer: footerMenu
}
